export const messages = {
  resetFilters: {
    id: "audiences.reset-filters",
    defaultMessage: "Reset Filters",
  },
};
